import {
  DEFAULT_PAGE,
  DEFAULT_ROWS_PER_PAGE,
} from "constants/paginationConstants";
import { atom } from "jotai";

export const driverFiltersAtom = atom({
  fullName: "",
  phoneNumber: "",
  city: "",
  status: [],
});

export const driverPageAtom = atom(DEFAULT_PAGE);
export const driverRowsPerPageAtom = atom(DEFAULT_ROWS_PER_PAGE);

export const descendingNameSortAtom = atom(null);
export const descendingAgeSortAtom = atom(null);
export const descendingCreationDateSortAtom = atom(null);
export const descendingModificationDateSortAtom = atom(null);
